import { ApiService } from "./api-service"
import config from "../config"

class PPApiService extends ApiService {
  baseUrl = config.ppApi.url

  lookup(code: string): Promise<any> {
    return this.get(["lookup", code])
  }

  getIncident(id: string): Promise<any> {
    return this.get(["incidents", id])
  }

  getIncidentVideos(id: string, since: number): Promise<any> {
    return this.get(["incidents", id, "videos", since.toString()])
  }

  getIncidentByToken(token: string): Promise<any> {
    return this.get(["incident", "token", token])
  }

  cancelDispatch(cancelReq: Object): Promise<any> {
    return this.post(["incident", "dispatch", "cancel"], cancelReq)
  }

  saveRecentIncidentView(body: Object): Promise<any> {
    return this.post(["incident", "saveincidentview"], body)
  }
}

export const ppApiService = new PPApiService()
